export const orderColumnValues = {
    productionPlanId : 'production_plan_id',
    year : 'year',
    planningSeason : 'planning_season',
    season : 'season',
    itemBrand : 'item_brand',
    businessUnit : 'business_unit',
    itemCode : 'item_code',
    itemName : 'itemName',
    mainSampleCode : 'main_sample_code',
    mainSampleName : 'main_sample_name',
    supplierRMCode : 'supplier_rm_code',
    supplierRMName : 'supplier_rm_name',
    vendorCode : 'vendor_code',
    vendorName : 'vendor_name',
    managementFactoryCode : 'management_factory_code',
    managementFactoryName : 'management_factory_name',
    branchFactoryCode : 'branch_factory_code',
    branchFactoryName : 'branch_factory_name',
    rmSupplierCode : 'rm_supplier_code',
    rmSupplierName : 'rm_supplier_name',
    sewingDifficulty : 'sewing_difficulty',
    departmentCode : 'department_code',
    departmentName : 'department_name',
    class1Code : 'class1_code',
    Class1Name : 'class1_name',
    productionPlanTypeName : 'prod_plan_type_name',
    monthWeekFlag : 'month_week_flag',
    lastUpdateDate : 'last_update_date',
    requestedWhDate : 'requested_wh_date',
    contractedDate : 'contracted_date',
    transportMethodName : 'transport_method_name',
    logisticsTypeName : 'logistics_type_name',
    orderQtyPcs : 'order_qty_pcs',
    yarnOrderAcceptance : 'yarn_order_acceptance',
    yarnOrderRequestDate : 'yarn_order_req_date',
    yarnOrderAnswerDate : 'yarn_order_ans_date',
    yarnOrderActualDate : 'yarn_order_actual_ate',
    yarnOrderNO : 'yarn_order_no',
    yarnActualOrderQtyPcs : 'yarn_actual_order_qty_pcs',
    yarnUpdateDate : 'yarn_update_date',
    fabricOrderAcceptance : 'fabric_order_acceptance',
    fabricOrderRequestDate : 'fabric_order_req_date',
    fabricOrderAnswerDate : 'fabric_order_ans_date',
    fabricOrderActualDate : 'fabric_order_actual_date',
    fabricOrderNO : 'fabric_order_no',
    fabricActualOrderQtyPcs : 'fabric_actual_order_qty_pcs',
    fabricUpdateDate : 'fabric_update_date',
    colorOrderAcceptance : 'color_order_acceptance',
    colorOrderRequestDate : 'color_order_req_date',
    colorOrderAnswerDate : 'color_order_ans_date',
    colorOrderActualDate : 'color_order_actual_date',
    colorOrderNO : 'color_order_no',
    colorActualOrderQtyPcs : 'color_actual_order_qty_pcs',
    colorUpdateDate : 'color_update_date',
    trimOrderAcceptance : 'trim_order_acceptance',
    trimOrderRequestDate : 'trim_order_req_date',
    trimOrderAnswerDate : 'trim_order_ans_date',
    trimOrderActualDate : 'trim_order_actual_date',
    trimOrderNO : 'trim_order_no',
    trimActualOrderQtyPcs : 'trim_actual_order_qty_pcs',
    trimUpdateDate : 'trim_update_date',
    POOrderAcceptance : 'po_order_acceptance',
    POOrderRequestDate : 'po_order_req_date',
    POOrderAnswerDate : 'po_order_ans_date',
    POOrderActualDate : 'po_order_actual_date',
    POOrderNO : 'po_order_no',
    POActualOrderQtyPcs : 'po_actual_order_qty_pcs',
    POUpdateDate : 'po_update_date',
    orderQtyPcsOld : 'order_qty_pcs_old',
    transportMethodNameOld : 'transport_method_name_old',
    logisticsTypeNameOld : 'logistics_type_name_old',
    yarnOrderRequestDateOld : 'yarn_order_req_date_old',
    fabricOrderRequestDateOld : 'fabric_order_req_date_old',
    colorOrderRequestDateOld : 'color_order_req_date_old',
    trimOrderRequestDateOld : 'trim_order_req_date_old',
    POOrderRequestDateOld : 'po_order_req_date_old',
    status : 'status',
    displayMonthWK : 'display_month_wk',
    displayMonthWKColumn : 'display_month_wk_column',
    groupCd : 'group_cd',
    showColorFlag : 'show_color_flag',
    orderQtyCoeff : 'orderqty_coeff',
    factoryComment : 'factory_comment',
    factoryCommentUpdateDate : 'factory_comment_update_date',
    FRFabricCode : 'fr_fabric_code',
    FRFabricName : 'fr_fabric_name',
    Ph1FirstDiscriminationFlagOld : 'ph1_first_disc_flag_old',
    Ph1FirstDiscriminationFlag : 'ph1_first_disc_flag',
    orderTimingDisplayValueOld : 'order_timing_display_value_old',
    orderTimingDisplayValue : 'order_timing_display_value',
    expressLineFlagOld : 'express_line_flag_old',
    expressLineFlag : 'express_line_flag',
    manualLockFlagOld : 'manual_lock_flag_old',
    manualLockFlag : 'manual_lock_flag',
    Ph1FirstDiscriminationFlagNow : 'ph1_first_disc_flag_now',
    orderTimingDisplayValueNow : 'order_timing_display_value_now',
    expressLineFlagNow : 'express_line_flag_now',
    ManualLockFlagNow : 'manual_lock_flag_now',
    requestedWhDateOld : 'req_wh_date_old',
    EXF : 'exf',
    colorRecommend : 'color_recommend',
    trimRecommend : 'trim_recommend',
    PORecommend : 'po_recommend',
    BD_EXF_DLSettingLTBeforeCal : 'bd_exf_dlsetting_ltbefore_cal',
    PO_EXF_DLSettingLTBeforeCal : 'po_exf_dlsetting_ltbefore_cal',
    materialSupplierHolidayExcluding : 'material_supl_holiday_excl',
    sewingFTYHolidayExcluding : 'sewing_fty_holiday_excl',
    BD_EXF_DLSettingLT : 'bd_exf_dlsetting_lt',
    PO_EXF_DLSettingLT : 'po_exf_dlsetting_lt',
    BD_EXFRegisteredLT : 'bd_exf_reg_lt',
    PO_EXFRegisteredLT : 'po_exf_reg_lt',
    BD_EXFtotalAbnormalLT : 'bd_exf_total_abnormal_lt',
    PO_EXFtotalAbnormalLT : 'po_exf_total_abnormal_lt',
    abnormalLTReasonBD1 : 'abnormal_lt_reason_bd1',
    abnormalLTReasonBD2 : 'abnormal_lt_reason_bd2',
    abnormalLTReasonBD3 : 'abnormal_lt_reason_bd3',
    abnormalLTReasonBD4 : 'abnormal_lt_reason_bd4',
    abnormalLTReasonBD5 : 'abnormal_lt_reason_bd5',
    abnormalLTBD1 : 'abnormal_lt_bd1',
    abnormalLTBD2 : 'abnormal_lt_bd2',
    abnormalLTBD3 : 'abnormal_lt_bd3',
    abnormalLTBD4 : 'abnormal_lt_bd4',
    abnormalLTBD5 : 'abnormal_lt_bd5',
    abnormalLTReasonPO1 : 'abnormal_lt_reason_po1',
    abnormalLTReasonPO2 : 'abnormal_lt_reason_po2',
    abnormalLTReasonPO3 : 'abnormal_lt_reason_po3',
    abnormalLTReasonPO4 : 'abnormal_lt_reason_po4',
    abnormalLTReasonPO5 : 'abnormal_lt_reason_po5',
    abnormalLTPO1 : 'abnormal_lt_po1',
    abnormalLTPO2 : 'abnormal_lt_po2',
    abnormalLTPO3 : 'abnormal_lt_po3',
    abnormalLTPO4 : 'abnormal_lt_po4',
    abnormalLTPO5 : 'abnormal_lt_po5',
}